export async function getBillingRecords(client_id = '', payment_status = '', start_date = '', end_date = '', payment_date='') {
    try {
        // API Base URL
        const baseUrl = 'https://ps5fjirz7c.execute-api.ap-southeast-1.amazonaws.com/prod/getBillingRecords';

        // Build query string based on provided parameters
        const queryParams = new URLSearchParams();

        if (client_id) {
            queryParams.append('client_id', client_id);
        }
        if (payment_status) {
            queryParams.append('payment_status', payment_status);
        }
        if (start_date) {
            queryParams.append('start_date', start_date);
        }
        if (end_date) {
            queryParams.append('end_date', end_date);
        }
        if (payment_date) {
            queryParams.append('payment_date', payment_date);
        }

        // Construct final API URL with query parameters
        const apiUrl = queryParams.toString() ? `${baseUrl}?${queryParams.toString()}` : baseUrl;

        // Make the API call
        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        // Check for a successful response
        if (response.ok) {
            const data = await response.json();
            return data; // Return the fetched billing records
        } else {
            console.error(`Error: Failed to fetch billing records. Status: ${response.status}`);
            return null;
        }
    } catch (error) {
        // Catch any network or other errors
        console.error('Error: Network or other error occurred while fetching billing records.', error);
        return null;
    }
}

export async function getBillingRecord(id) {
    try {
        // Make the API call using the provided billing record ID
        const response = await fetch(`https://1k5d0h2tb2.execute-api.ap-southeast-1.amazonaws.com/prod/getBillingRecord/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        // Check for a successful response
        if (response.ok) {
            const data = await response.json();
            return data;  // Return the billing record data
        } else {
            console.error(`Error: Failed to fetch billing record. Status: ${response.status}`);
            return null;
        }
    } catch (error) {
        // Catch any network or other errors
        console.error('Error: Network or other error occurred while fetching the billing record.', error);
        return null;
    }
}




export async function postBillingRecord(billingRecordParameters = {}) {
    // Construct the payload with spread syntax
    const billingRecordPayload = {
        ...billingRecordParameters, // Spread all properties from billingRecordParameters
    };

    try {
        // Make the API call
        const response = await fetch('https://6bu5phzmgg.execute-api.ap-southeast-1.amazonaws.com/prod/postBillingRecord', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(billingRecordPayload),
        });

        // Check for a successful response
        if (response.ok) {
            return await response.json(); // Return the response as JSON
        } else {
            console.error(`Error: Failed to post billing record data. Status: ${response.status}`);
            return null;
        }
    } catch (error) {
        // Catch any network or other errors
        console.error('Error: Network or other error occurred while posting billing record data.', error);
        return null;
    }
}


export async function putBillingRecord(id, billingRecordParameters = {}) {
    // Prepare the payload for submission using the passed billingRecordParameters
    const submitData = {
        ...billingRecordParameters, // Spread all the properties from billingRecordParameters
    };

    try {
        console.log('Submitting updated billing record data:', submitData);

        const response = await fetch(`https://rqom0hj4n0.execute-api.ap-southeast-1.amazonaws.com/prod/putBillingRecord/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(submitData), // Convert the payload to JSON
        });

        const result = await response.json();

        if (response.ok) {
            console.log('Billing record updated successfully!', result);
            return { success: true, data: result };
        } else {
            console.error('Error updating billing record:', result);
            return { success: false, error: result };
        }
    } catch (error) {
        console.error('Network or other error occurred while updating billing record:', error);
        return { success: false, error };
    }
}